<template>
  <transition name="modal" appear>
    <div class="modal-mask compare-preview-modal" v-if="visible">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="compare-preview-shell">
            <div class="modal-header">
              <h1>Compare</h1>
              <button type="button" class="compare-preview-close" @click="close">
                <img
                  src="../../../assets/img/icn_close.svg"
                  alt=""
                  class="compare-preview-close-icon"
                  aria-hidden="true"
                />
                <span>Close</span>
              </button>
            </div>

            <div class="compare-preview-body">
              <div
                class="compare-preview-grid"
                :class="{ 'compare-preview-grid--narrow': isNarrow }"
                :style="compareGridStyle"
              >
                <div
                  v-if="!isNarrow"
                  class="compare-preview-cell compare-preview-cell--label compare-preview-cell--label-empty"
                ></div>
                <div
                  v-for="item in compareItems"
                  :key="'img-' + item.compareEntryId"
                  class="compare-preview-cell compare-preview-cell--task compare-preview-cell--image"
                >
                  <div class="compare-preview-task-card compare-preview-task-card--image-only">
                    <button
                      type="button"
                      class="compare-preview-task-card__remove"
                      aria-label="Remove from compare"
                      @click="remove(item.compareEntryId)"
                    >
                      <img
                        src="../../../assets/img/icn_close_outline.svg"
                        alt=""
                        aria-hidden="true"
                      />
                    </button>
                    <div class="compare-preview-task-card__image">
                      <img
                        v-if="item.images && item.images.length"
                        :src="getImageUrl(item)"
                        :alt="item.title || ''"
                      />
                      <img
                        v-else
                        src="../../../assets/img/no-image-available.jpg"
                        alt=""
                      />
                    </div>
                  </div>
                </div>

                <div
                  v-if="!isNarrow"
                  class="compare-preview-cell compare-preview-cell--label compare-preview-cell--label-task"
                >Task</div>
                <div
                  v-for="item in compareItems"
                  :key="'title-' + item.compareEntryId"
                  class="compare-preview-cell compare-preview-cell--task-title"
                >
                  <div v-if="isNarrow" class="compare-preview-cell-heading">Task</div>
                  <p class="compare-preview-task-card__title body-large strong">{{ item.title }}</p>
                </div>

                <hr class="compare-preview-row-divider" />

                <div v-if="!isNarrow" class="compare-preview-cell compare-preview-cell--label">Total Cost</div>
                <div
                  v-for="item in compareItems"
                  :key="'cost-' + item.compareEntryId"
                  class="compare-preview-cell"
                >
                  <div v-if="isNarrow" class="compare-preview-cell-heading">Total Cost</div>
                  ${{ item.priceIncGst }} inc GST
                </div>

                <hr class="compare-preview-row-divider" />

                <div v-if="!isNarrow" class="compare-preview-cell compare-preview-cell--label">Qty</div>
                <div
                  v-for="item in compareItems"
                  :key="'qty-' + item.compareEntryId"
                  class="compare-preview-cell"
                >
                  <div v-if="isNarrow" class="compare-preview-cell-heading">Qty</div>
                  {{ item.qty }}
                </div>

                <hr class="compare-preview-row-divider" />

                <div v-if="!isNarrow" class="compare-preview-cell compare-preview-cell--label">Difficulty</div>
                <div
                  v-for="item in compareItems"
                  :key="'diff-' + item.compareEntryId"
                  class="compare-preview-cell"
                >
                  <div v-if="isNarrow" class="compare-preview-cell-heading">Difficulty</div>
                  {{ displayDifficulty(item) }}
                </div>

                <hr class="compare-preview-row-divider" />

                <div v-if="!isNarrow" class="compare-preview-cell compare-preview-cell--label">Product</div>
                <div
                  v-for="item in compareItems"
                  :key="'product-' + item.compareEntryId"
                  class="compare-preview-cell"
                >
                  <div v-if="isNarrow" class="compare-preview-cell-heading">Product</div>
                  {{ selectedProductLabel(item) }}
                </div>

                <hr class="compare-preview-row-divider" />

                <div v-if="!isNarrow" class="compare-preview-cell compare-preview-cell--label">Type</div>
                <div
                  v-for="item in compareItems"
                  :key="'type-' + item.compareEntryId"
                  class="compare-preview-cell"
                >
                  <div v-if="isNarrow" class="compare-preview-cell-heading">Type</div>
                  {{ selectedProductTypeLabel(item) }}
                </div>

                <hr class="compare-preview-row-divider" />

                <div v-if="!isNarrow" class="compare-preview-cell compare-preview-cell--label">Brand</div>
                <div
                  v-for="item in compareItems"
                  :key="'brand-' + item.compareEntryId"
                  class="compare-preview-cell"
                >
                  <div v-if="isNarrow" class="compare-preview-cell-heading">Brand</div>
                  {{ selectedProductBrandLabel(item) }}
                </div>

                <hr class="compare-preview-row-divider" />

                <div v-if="!isNarrow" class="compare-preview-cell compare-preview-cell--label">Warranty</div>
                <div
                  v-for="item in compareItems"
                  :key="'warranty-' + item.compareEntryId"
                  class="compare-preview-cell"
                >
                  <div v-if="isNarrow" class="compare-preview-cell-heading">Warranty</div>
                  {{ selectedProductWarrantyLabel(item) }}
                </div>

                <hr class="compare-preview-row-divider" />

                <div v-if="!isNarrow" class="compare-preview-cell compare-preview-cell--label"></div>
                <div
                  v-for="item in compareItems"
                  :key="'act-' + item.compareEntryId"
                  class="compare-preview-cell compare-preview-cell--action"
                >
                  <div v-if="isNarrow" class="compare-preview-cell-heading">Actions</div>
                  <button
                    type="button"
                    class="compare-preview-add-btn ui primary button"
                    :class="{ disabled: item.addedToQuote }"
                    :disabled="item.addedToQuote"
                    @click="addToQuote(item)"
                  >
                    {{ item.addedToQuote ? 'Added' : 'Add to Quote' }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { useCompare } from '../../../helpers/useCompare'

const LABEL_COL_WIDTH = 120
const TASK_COL_WIDTH = 220

export default {
  name: 'ComparePreviewModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      isNarrow: false,
      _mq: null,
      _mqHandler: null
    }
  },
  computed: {
    compareItems: function () {
      return this.$store.getters['compare/compareItems']
    },
    compareGridStyle: function () {
      const n = Math.max(this.compareItems.length, 1)
      const taskCols = Array(n).fill(TASK_COL_WIDTH + 'px').join(' ')
      if (this.isNarrow) {
        return { gridTemplateColumns: taskCols }
      }
      return { gridTemplateColumns: LABEL_COL_WIDTH + 'px ' + taskCols }
    }
  },
  watch: {
    visible: function (v) {
      if (v) {
        document.body.classList.add('no-scroll')
      } else {
        document.body.classList.remove('no-scroll')
      }
    }
  },
  mounted: function () {
    this._mq = window.matchMedia('(max-width: 767px)')
    this._mqHandler = () => {
      this.isNarrow = this._mq.matches
    }
    this._mqHandler()
    if (this._mq.addEventListener) {
      this._mq.addEventListener('change', this._mqHandler)
    } else {
      this._mq.addListener(this._mqHandler)
    }
    window.addEventListener('resize', this._mqHandler)
  },
  beforeUnmount: function () {
    document.body.classList.remove('no-scroll')
    if (this._mq && this._mqHandler) {
      if (this._mq.removeEventListener) {
        this._mq.removeEventListener('change', this._mqHandler)
      } else {
        this._mq.removeListener(this._mqHandler)
      }
    }
    window.removeEventListener('resize', this._mqHandler)
  },
  methods: {
    getComparedProducts: function (item) {
      if (!item || !Array.isArray(item.variables)) return []
      return item.variables.filter(Boolean)
    },
    formatCompareValue: function (value) {
      if (value == null || value === '') return ''
      return String(value)
    },
    getTypeNameById: function (typeId) {
      const raw = this.formatCompareValue(typeId)
      if (!raw) return ''
      const types = (this.$store && this.$store.getters && this.$store.getters['material/getTypes']) || []
      const match = Array.isArray(types)
        ? types.find((t) => t && (String(t.id) === raw || String(t.order_id) === raw))
        : null
      return match && match.name ? String(match.name) : raw
    },
    getBrandNameById: function (brandId) {
      const raw = this.formatCompareValue(brandId)
      if (!raw) return ''
      const brands = (this.$store && this.$store.getters && this.$store.getters['product/getBrands']) || []
      const match = Array.isArray(brands)
        ? brands.find((b) => b && String(b.id) === raw)
        : null
      return match && match.name ? String(match.name) : raw
    },
    uniqueLabelsOrDash: function (labels) {
      const clean = labels
        .map(v => this.formatCompareValue(v).trim())
        .filter(Boolean)
      const unique = Array.from(new Set(clean))
      return unique.length ? unique.join(', ') : '–'
    },
    displayDifficulty: function (item) {
      if (!item || item.difficultyLabel == null || item.difficultyLabel === '') return '–'
      return item.difficultyLabel
    },
    selectedProductLabel: function (item) {
      const labels = this.getComparedProducts(item)
        .map(function (v) {
          if (!v) return ''
          return v.title || v.description || v.name || ''
        })
      return this.uniqueLabelsOrDash(labels)
    },
    selectedProductTypeLabel: function (item) {
      const labels = this.getComparedProducts(item)
        .map((v) => {
          if (!v) return ''
          if (v.type_name) return v.type_name
          if (v.product_type_name) return v.product_type_name
          if (v.product_type != null) return this.getTypeNameById(v.product_type)
          if (v.type != null) return this.getTypeNameById(v.type)
          return ''
        })
      return this.uniqueLabelsOrDash(labels)
    },
    selectedProductBrandLabel: function (item) {
      const labels = this.getComparedProducts(item)
        .map((v) => {
          if (!v) return ''
          if (v.brand_name) return v.brand_name
          if (v.brand != null && isNaN(Number(v.brand))) return v.brand
          if (v.brand_id != null) return this.getBrandNameById(v.brand_id)
          if (v.brand != null) return this.getBrandNameById(v.brand)
          return ''
        })
      return this.uniqueLabelsOrDash(labels)
    },
    selectedProductWarrantyLabel: function (item) {
      const labels = this.getComparedProducts(item)
        .map((v) => {
          if (!v) return ''
          return v.warranty || v.warranty_period || v.warranty_text || ''
        })
      return this.uniqueLabelsOrDash(labels)
    },
    close: function () {
      useCompare().setComparePreviewOpen(false)
      this.$emit('close')
    },
    remove: function (compareEntryId) {
      useCompare().removeFromCompare(compareEntryId)
      if (!useCompare().compareItems.length) {
        this.close()
      }
    },
    addToQuote: function (item) {
      if (item.addedToQuote) return
      this.$emit('add', item)
      useCompare().markAddedToQuote(item.compareEntryId)
    }
  }
}
</script>
